import Stomp from "stompjs";
import env from "env";

const createNoopClient = () => ({
  connect: () => {},
  subscribe: () => ({ unsubscribe: () => {} }),
  disconnect: () => {},
});

const subscriptions = (channel, cb, id) => {
  const websocketDisabled =
    env.enableWebSocket === false || !String(env.webSocketSrc || "").trim();
  if (websocketDisabled) {
    return createNoopClient();
  }
  let stompClient = Stomp.client(env.webSocketSrc);
  const headers = {
    login: env.rmUser,
    passcode: env.rmPsd,
    durable: "true",
    "auto-delete": "false",
  };
  stompClient.connect(headers, function (frame) {
    const subscription = stompClient.subscribe(channel, cb, {id});
  });
  return stompClient
};

export const todosSubscription = (id, cb) =>
  subscriptions(`/queue/user_mq_${id}`, cb, 'todos');

export const boardSubscription = (id, cb) =>
  subscriptions(`/exchange/project_${id}`, cb, 'board');

export const wechatSubscription = (id, cb) =>
 subscriptions(`/queue/wechat_bind_${id}`, cb, 'wechat');

